import React from 'react';
import PropTypes from 'prop-types';

import Image from '../../atoms/Image';

import * as S from './ImageContainer.styles';

const ImageContainer = (props) => {
  const {
    image,
    className,
    imageWidth,
    imageHeight,
    maxWidth,
    minWidth,
    display,
    padding,
  } = props;

  return (
    <S.ImageContainer
      className={className}
      imageWidth={imageWidth}
      imageHeight={imageHeight}
      maxWidth={maxWidth}
      minWidth={minWidth}
      displaty={display}
      padding={padding}
    >
      <Image
        id={image.id}
        src={image.src}
        alt={image.alt}
        className={image.className}
        objectFit={image.objectFit}
      />
    </S.ImageContainer>
  );
};

ImageContainer.propTypes = {
  image: PropTypes.shape({
    id: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
    objectFit: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  imageWidth: PropTypes.string,
  imageHeight: PropTypes.string,
  maxWidth: PropTypes.string,
  minWidth: PropTypes.string,
  display: PropTypes.string,
  padding: PropTypes.string,
};

ImageContainer.defaultProps = {
  className: '',
  imageWidth: '100%',
  imageHeight: '100%',
  maxWidth: 'content-max',
  minWidth: 'content-max',
  display: 'block',
  padding: '0',
};

export default ImageContainer;
